import { ThemeOptions } from "@mui/material";

export const themeTypography: ThemeOptions["typography"] = {
  fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600
};
